"use client";

import React from "react";
import { Facebook, Twitter, Instagram, MapPin, Phone, Mail, Clock, ChevronRight, Youtube } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
const socialLinks = [{
  icon: Facebook,
  href: "#",
  label: "Facebook"
}, {
  icon: Twitter,
  href: "#",
  label: "Twitter"
}, {
  icon: Instagram,
  href: "#",
  label: "Instagram"
}, {
  icon: Youtube,
  href: "#",
  label: "YouTube"
}];
const inventoryLinks = [{
  label: "Hail & Storm Damage",
  href: "/CaravanMotorhomeServicingInSydneyPage"
}, {
  label: "Insurance Repair Specialists",
  href: "/CaravanMotorhomeServicingInSydneyPage"
}, {
  label: "Solar & Battery Systems",
  href: "/SolarBatterySystemsGeneratorsPage"
}, {
  label: "Electrical & Plumbing",
  href: "/CaravanMotorhomeServicingInSydneyPage"
}, {
  label: "Structural & Chassis Repair",
  href: "/CaravanMotorhomeServicingInSydneyPage"
}];
const contactInfo = {
  address: "45 Drummond St, South Windsor, NSW 2756",
  phone: "(02) 4577 6666",
  email: "service@caravansmashrepairs.com.au",
  hours: "Mon-Fri: 8:00am - 4:30pm; Sat: By Appointment; Sun: Closed"
};
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="167815" className="flex flex-col gap-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-5 w-32 bg-muted animate-pulse rounded-md" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="flex flex-col gap-3">
        <li data-index={0}>
          <Link to="/HomePage" className="text-primary-foreground/70 hover:text-accent transition-colors flex items-center gap-2 text-sm group font-sans">
            <ChevronRight className="size-4 text-accent/50 group-hover:text-accent transition-colors" />
            Home
          </Link>
        </li>
        <li data-index={1}>
          <Link to="/OurStoryPage" className="text-primary-foreground/70 hover:text-accent transition-colors flex items-center gap-2 text-sm group font-sans">
            <ChevronRight className="size-4 text-accent/50 group-hover:text-accent transition-colors" />
            Our Story
          </Link>
        </li>
        <li data-index={2}>
          <Link to="/CaravanMotorhomeServicingInSydneyPage" className="text-primary-foreground/70 hover:text-accent transition-colors flex items-center gap-2 text-sm group font-sans">
            <ChevronRight className="size-4 text-accent/50 group-hover:text-accent transition-colors" />
            Servicing
          </Link>
        </li>
        <li data-index={3}>
          <Link to="/StartYourQuotePage" className="text-primary-foreground/70 hover:text-accent transition-colors flex items-center gap-2 text-sm group font-sans">
            <ChevronRight className="size-4 text-accent/50 group-hover:text-accent transition-colors" />
            Get a Quote
          </Link>
        </li>
      </ul>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-primary-foreground/70 hover:text-accent transition-colors flex items-center gap-2 text-sm group font-sans">
            <ChevronRight className="size-4 text-accent/50 group-hover:text-accent transition-colors" />
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function DealershipHubFooter() {
  const currentYear = new Date().getFullYear();
  return <section id="footer" className="bg-primary text-primary-foreground border-t-4 border-accent relative overflow-hidden font-sans">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[1px] bg-accent shadow-[0_0_40px_20px_rgba(251,146,60,0.15)] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12 lg:gap-8 mb-16">
          
          {}
          <div className="lg:col-span-4 flex flex-col items-start">
            <Link to="/HomePage" className="mb-6 block">
              <img src="https://climbing-camel.10web.cloud/wp-content/uploads/2026/03/Untitled-design-13.png" alt="Caravan Smash Repairs Logo" className="object-contain brightness-0 invert !opacity-[1] !rounded-none !w-[52px] !h-[52px]" />
            </Link>
            <p className="text-primary-foreground/70 text-sm mb-8 max-w-sm leading-relaxed font-sans">
              Sydney&apos;s specialist in insurance and private caravan restoration. From hail damage to structural repairs, we ensure your home-on-wheels is road-ready with industrial precision.
            </p>
            <div className="flex items-center gap-2">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Button key={i} data-index={i} variant="ghost" size="icon" className="text-primary-foreground/70 hover:text-accent hover:bg-accent/10 rounded-sm transition-all" asChild>
                    <Link to={social.href} aria-label={social.label}>
                      <Icon className="size-5" />
                    </Link>
                  </Button>;
            })}
            </div>
          </div>

          {}
          <div className="lg:col-span-2">
            <h3 className="text-accent font-bold tracking-widest mb-6 uppercase text-xs font-sans">
              Quick Links
            </h3>
            <MenuProvider menu_id="45">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="lg:col-span-3">
            <h3 className="text-accent font-bold tracking-widest mb-6 uppercase text-xs font-sans">
              Our Services
            </h3>
            <ul className="flex flex-col gap-3">
              {inventoryLinks.map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.href} className="text-primary-foreground/70 hover:text-accent transition-colors flex items-center gap-2 text-sm group font-sans">
                    <ChevronRight className="size-4 text-accent/50 group-hover:text-accent transition-colors" />
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="lg:col-span-3">
            <h3 className="text-accent font-bold tracking-widest mb-6 uppercase text-xs font-sans">
              Contact & Workshop
            </h3>
            <ul className="flex flex-col gap-4 mb-6">
              <li className="flex items-start gap-3 text-sm text-primary-foreground/70 font-sans">
                <MapPin className="size-5 text-accent shrink-0 mt-0.5" />
                <span>6/104 Ham St, South Windsor NSW 2756</span>
              </li>
              <li className="flex items-center gap-3 text-sm text-primary-foreground/70 font-mono">
                <Phone className="size-5 text-accent shrink-0" />
                <span>0401 316 697</span>
              </li>
              <li className="flex items-center gap-3 text-sm text-primary-foreground/70 font-mono">
                <Mail className="size-5 text-accent shrink-0" />
                <span className="break-all">caravansmashrepairs@yahoo.com</span>
              </li>
              <li className="flex items-start gap-3 text-sm text-primary-foreground/70 font-mono">
                <Clock className="size-5 text-accent shrink-0 mt-0.5" />
                <span className="whitespace-pre-line">Mon-Fri: 9:00am - 5:00pm
Sat: By Appointment; Sun: Closed</span>
              </li>
            </ul>

            {}
            <div className="inline-flex items-center gap-3 px-4 py-2.5 bg-secondary/10 border border-white/10 rounded-sm shadow-lg backdrop-blur-md">
              <span className="relative flex h-3 w-3">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-accent opacity-75"></span>
                <span className="relative inline-flex rounded-full h-3 w-3 bg-accent"></span>
              </span>
              <span className="text-xs font-bold uppercase tracking-wider text-primary-foreground font-sans">
                Workshop Open Now
              </span>
            </div>
          </div>

        </div>

        <Separator className="bg-white/10 mb-8" />

        {}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-primary-foreground/50 font-mono">
          <p>
            &copy; {currentYear} Caravan Smash Repairs. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link className="hover:text-accent transition-colors" to="#">Privacy Policy</Link>
            <Link className="hover:text-accent transition-colors" to="#">Terms of Service</Link>
            <Link className="hover:text-accent transition-colors" to="#">Sitemap</Link>
          </div>
        </div>
      </div>
    </section>;
}